export default __webpack_public_path__ + "static/media/bg_influence.9bad659a.jpg";